var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "20",
        viewBox: "0 0 17 20",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_8_3858)" } }, [
        _c("path", {
          attrs: {
            d: "M4.75 0.23291C5.40684 0.23291 5.9375 0.763574 5.9375 1.42041V2.60791H10.6875V1.42041C10.6875 0.763574 11.2182 0.23291 11.875 0.23291C12.5318 0.23291 13.0625 0.763574 13.0625 1.42041V2.60791H14.8438C15.8272 2.60791 16.625 3.40576 16.625 4.38916V6.17041H0V4.38916C0 3.40576 0.797852 2.60791 1.78125 2.60791H3.5625V1.42041C3.5625 0.763574 4.09317 0.23291 4.75 0.23291ZM0 7.35791H16.625V17.4517C16.625 18.4351 15.8272 19.2329 14.8438 19.2329H1.78125C0.797852 19.2329 0 18.4351 0 17.4517V7.35791ZM2.96875 9.73292C2.64219 9.73292 2.375 10.0001 2.375 10.3267V13.8892C2.375 14.2157 2.64219 14.4829 2.96875 14.4829H6.53125C6.85782 14.4829 7.125 14.2157 7.125 13.8892V10.3267C7.125 10.0001 6.85782 9.73292 6.53125 9.73292H2.96875Z",
            fill: "currentColor",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_8_3858" } }, [
          _c("rect", {
            attrs: {
              width: "16.625",
              height: "19",
              fill: "white",
              transform: "translate(0 0.23291)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }